// noinspection JSUnresolvedReference

(function(app) {
    const elements = {};

    app.SetToggle = {
        init() {
			elements.setToggleEl = document.querySelector('.wdpp-input-set .wdpp-checkbox');
            
            // Validate required elements
            if (!app.Utils.validateElements('set inputs', {
                'set toggle checkbox': '.wdpp-input-set .wdpp-checkbox'
            })) {
                return;
            }

            elements.setToggleEl.addEventListener('change', () => {
				app.Store.setState('isSet', elements.setToggleEl.checked);
            });

            app.Store.subscribe('initialized', () => {
                app.Store.setState('isSet', elements.setToggleEl.checked);
            });
        },
        
        /**
         * Get the set data for cart export
         * @returns {object} The set data for the cart
         */
        getCartData() {
            return {
                isSet: app.Store.getState('isSet') || false
            };
        },

        /**
         * Get the set data for price calculation
         * @returns {object} The set data for the price
         */
        getPriceData() {
            return {
                isSet: app.Store.getState('isSet') || false
            };
        }
    };
})(window.app = window.app || {});